/** Matches `SeoLinkItem` link typography used for intrinsic width. */
const SEO_LINK_MEASURE_CLASS = 'body-copy-l-bold';

/**
 * Ephemeral DOM measurement (same idea as InlineTruncationText): append a hidden
 * probe, read widths, remove — never leave a `w-max` row in the React tree.
 */
export function measureSeoLinkWidths(names: readonly string[], host: HTMLElement): number[] {
    const probe = document.createElement('span');
    probe.setAttribute('aria-hidden', 'true');
    probe.className = SEO_LINK_MEASURE_CLASS;
    probe.style.cssText = [
        'position:absolute',
        'left:0',
        'top:0',
        'visibility:hidden',
        'pointer-events:none',
        'white-space:nowrap',
    ].join(';');

    host.appendChild(probe);
    try {
        return names.map((name) => {
            probe.textContent = name;
            return probe.getBoundingClientRect().width;
        });
    } finally {
        probe.remove();
    }
}
